import { MediaButton, PlayPauseContainer } from './PlayPauseButton.styled';

interface PlayPauseButtonProps {
  isPlaying: boolean;
  togglePlayPause: () => void;
}

export const PlayPauseButton = ({ isPlaying, togglePlayPause }: PlayPauseButtonProps) => (
  <PlayPauseContainer data-testid="play-pause-button-container" onClick={togglePlayPause}>
    <MediaButton data-testid="play-pasue-button">
      <svg data-testid="play-pasue-button-icon">
        <use href={isPlaying ? '#pause' : '#play'} />
      </svg>
    </MediaButton>
  </PlayPauseContainer>
);
